var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.001,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.002 16a8 8 0 118-8 8.011 8.011 0 01-8 8zm-1-6v2h2v-2zm.994-6a1 1 0 00-.994 1v3a1 1 0 102 0V5a1 1 0 00-1-1z",
    fill: "#ff4242"
  })));
}
export default SvgAttention;